import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=28c8922c&scoped=true&"
import script from "./Preview.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Preview.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Preview.vue?vue&type=style&index=0&id=28c8922c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c8922c",
  null
  
)

export default component.exports